import { useMemo } from "react"

import { useQueryClient } from "@tanstack/react-query"
import type { QueryKey } from "@tanstack/react-query"

export const useInvalidateQueries = () => {
  const queryClient = useQueryClient()
  return useMemo(
    () => ({
      invalidateQueries: (queryKeys: QueryKey[]) => {
        queryKeys.forEach((queryKey) => {
          const [name, action, key] = queryKey
          void queryClient.invalidateQueries({
            predicate: ({ queryKey: [n, a, k] }) =>
              name === n &&
              (action === null || action === a) &&
              (key === null || key === k),
          })
        })
      },
    }),
    [queryClient]
  )
}
